import React, { useState } from 'react';
import ButtonSpinner from '../ButtonSpinner/ButtonSpinner';
import { useToast } from '../../../context/ToastContext';
import { downloadCompetitionDocument } from '../../../services/competitionWorkflowService';
import styles from './DocxDownloadButton.module.css';

// Downloads an approved deliverable as .docx. Disabled (with a hint) until the
// relevant part is approved.
const DocxDownloadButton = ({ enrollmentId, docKey, label, approved, prominent = false }) => {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      await downloadCompetitionDocument(enrollmentId, docKey);
    } catch (e) {
      toast.error(e.message || 'Download failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={`${styles.btn} ${prominent ? styles.prominent : ''}`}
      onClick={download}
      disabled={!approved || busy}
      title={approved ? `Download ${label}` : 'Available once all relevant parts are approved'}
    >
      {busy ? <ButtonSpinner size={12} /> : <span className={styles.glyph}>↓</span>}
      {label}
      {!approved && <span className={styles.lock}>· locked</span>}
    </button>
  );
};

export default DocxDownloadButton;
